export const confirmAction = (action) => window.confirm(`Are you sure you want to ${action}?`);
